<template>
	<div>
		<div class="input-group input-group-md">
			<input :class="{'has-danger': $props.showTextDangerSubgrupo}" type="text" class="form-control" :disabled="true" v-model="subgrupoSelecionado.nome">
			<span class="input-group-btn">
				<button :class="{'btn-danger': $props.showTextDangerSubgrupo, 'btn-default': !$props.showTextDangerSubgrupo}" type="button" @click="showModal = true" class="btn btn-default btn-flat"><i class="fa fa-search"></i></button>
				<button ref="btnBuscarLimpar" :class="{'btn-danger': $props.showTextDangerSubgrupo, 'btn-default': !$props.showTextDangerSubgrupo}" type="button" @click="limpar()" class="btn btn-flat"><i class="fa fa-trash-o"></i></button>
			</span>
		</div>

		<transition name="modal">
			<div class="modal-mask" v-show="showModal">
				<div class="modal-container">
					<div class="modal-header">
						<h3>Selecionar Subgrupo</h3>
					</div>
					<div class="modal-body">

						<div class="row">
							<div class="col-sm-12">
								<input type="text" class="form-control" v-model="filtros.pesquisa" @keyup.enter="getDataTable()" placeholder="Pesquisa: Entre com o nome do subgrupo e pressione enter." />
							</div>
						</div>


						<div class="row" v-if='loading'>
							<div class="col-sm-12" style="text-align: center; margin-top:30px;">
								<br/>
								<span style="text-align: center">Aguarde, processando...</span>
							</div>
						</div>

						<div class="row" style="margin-top:15px" v-else>
							<div class="col-sm-12 table-responsive">
								<table role="grid" class="table table-bordered table-striped">
									<thead>
										<tr role="row">
											<th style="width: 10%">ID</th>
											<th style="width: auto">Nome</th>
										</tr>
									</thead>
									<tbody>
										<tr @click="seleciona(item)" class="even hand" role="row" v-for="(item, index) in dataTable.data" :key="index">
											<td>{{ item.codigo }}</td>
											<td>{{ item.nome }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="text-right" style="float:right">
							<button class="btn btn-default" @click="showModal = false">
								<i class="fa fa-close"></i> Fechar
							</button>

						</div>
					</div>
				</div>

			</div>
		</transition>

	</div>
</template>

<script>

 import axios from "axios"; // Cliente para requisição http

 export default {
 	props:['nomeSubgrupo', 'showTextDangerSubgrupo'],

 	data: () => ({
 		loading: false,
 		subgrupoSelecionado: {
 			nome: null,
 		},
 		filtros: {
 			pesquisa: '',
 		},
 		showModal: false,
 		dataTable: {
 			data: []
 		}
 	}),
 	mounted() {
 		this.getDataTable();
 	},
 	methods: {
 		getDataTable (page) {

 			if (typeof page === 'undefined') {
 				page = 1;
 			}

 			this.filtros.page = page;
 			this.$store.commit('TOGGLE_LOADING');

 			let config = this.$store.getters.getHeaderAuth;
 			config.params = this.filtros;

 			axios.get(`${this.$store.state.serverURI}/api/cadastros/subgrupos-procedimento/getAllPaginate`, config)
 			.then(response => {
 				this.dataTable = response.data;
 				this.$store.commit('TOGGLE_LOADING');
 			}).catch((error) => { this.$store.commit('throwException', error); });

 		},
		limpar() {
			this.seleciona({ id: null, nome: '' })
		},
 		seleciona(item) {
 			this.subgrupoSelecionado = item;
 			this.showModal = false;
 			this.$emit('setSubgrupoSelecionado', item);
 		}
 	},
 	watch: {
 		"$props.nomeSubgrupo": function() {
 			if (this.$props.nomeSubgrupo) {
 				this.subgrupoSelecionado.nome = this.$props.nomeSubgrupo;
 			}
 		}
 	},
 	components: {}
 };

</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		transition: opacity 0.3s ease;
	}

	.modal-container {
		width: 70%;
		margin: 40px auto 0;
		padding: 10px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #333;
	}

	.modal-body {
		margin: 10px 0;
	}

	.text-right {
		text-align: right;
	}

	.form-label {
		display: block;
		margin-bottom: 1em;
	}

	.form-label>.form-control {
		margin-top: 0.5em;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.5em 1em;
		line-height: 1.5;
		border: 1px solid #ddd;
	}


	/*
	 * The following styles are auto-applied to elements with
	 * transition="modal" when their visibility is toggled
	 * by Vue.js.
	 *
	 * You can easily play with the modal transition by editing
	 * these styles.
	 */

	 .modal-enter {
	 	opacity: 0;
	 }

	 .modal-leave-active {
	 	opacity: 0;
	 }

	 .modal-enter .modal-container,
	 .modal-leave-active .modal-container {
	 	-webkit-transform: scale(1.1);
	 	transform: scale(1.1);
	 }

	 .modal {
	 	display: block !important;
	 	/* I added this to see the modal, you don't need this */
	 }


	 /* Important part */

	 .modal-dialog {
	 	overflow-y: initial !important;
	 }

	 .modal-body {
	 	height: 350px;
	 	overflow-y: auto;
	 }

	.has-danger {
		border-color: #D73925
	}
	</style>



// WEBPACK FOOTER //
// selectSubgrupo.vue?7574df3c